import { render } from "./TeamLogo.vue?vue&type=template&id=3195e15b"
import script from "./TeamLogo.vue?vue&type=script&lang=js"
export * from "./TeamLogo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Admin\\Documents\\LoesusPedagogia\\ArchiV2\\LP-MyFirstBusiness\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__